import { useRef, useState, useEffect } from 'react';
import {useToday} from "../../../components/hook/useToday";
import TagPicker from "rsuite/TagPicker";
import 'rsuite/TagPicker/styles/index.css';
import dayjs from 'dayjs';
import es from "dayjs/locale/es";
import Paquetes from "../../../components/catalogo/Paquetes";
import ErrorMessage from "../../../components/helpers/ErrorMessage";
import PeriodoDeContratacion from "../../../components/catalogo/PeriodoDeContratacion";
import { dataEstados } from "../../../components/catalogo/EstadosSelect";
import { conceptoText } from "../../perfilCliente/PerfilCliente";

////// FORM::Datos del paquete //////
export default function Step3({
    formik,
    catalogo,
    paqueteArray,
}) {
    ////// Valores en español de la libreria dayjs //////
    dayjs.locale(es);

    ////// Contenedor de TagPicker //////
    const taginputRef = useRef();
    ////// Cantidad máxima de los estados permitidos por paquete //////
    const [maxEstados, setMaxEstados] = useState(1);
    ////// Guardar las características de cada paquete //////
    const [conceptos, setConceptos] = useState({
        asuntos: "",
        consultas: "",
        historico: "",
    });
    ////// Arreglo de los estados seleccionados //////
    const [selectEstado, setSelectEstado] = useState([]);
    ////// Total del los estados disponibles //////
    const [estadosTag, setEstadosTag] = useState(dataEstados);
    ////// Manejo del TagPicker, mantenerlo abierto o cerrado  //////
    const [openTag, setOpenTag] = useState(false);
    ////// Manejo del TagPicker, deshabilitarlo  //////
    const [disableTag, setDisableTag] = useState(false);

    const sumaDia = useToday();

    const { setFieldValue } = formik;
    const desde_con = dayjs().add(sumaDia, 'days').format('YYYY MM DD');
    const { values } = formik;

    useEffect(() => {
        const paquetes = paqueteArray[0];
        //const sistemaLS = JSON.parse(localStorage.getItem("sistemaContratos")) ?? [];
        if (paquetes){
            setFieldValue('desde', dayjs().add(sumaDia, 'days').format('YYYY MMM DD'));
            setFieldValue('id_paquete', paquetes.id_paquete);
            setFieldValue('costo', paquetes.costo);
            setFieldValue('hasta', dayjs(desde_con).add(1, 'months').subtract(1, "day").format('YYYY MMM DD'));
            setConceptos({
                asuntos: paquetes.conceptos.find(a => a.id_concepto === '11000'),
                consultas: paquetes.conceptos.find(c => c.id_concepto === '12000'),
                historico: paquetes.conceptos.find(h => h.id_concepto === '13000'),
            });

            if ( values.sistema === 'BGDL') {
                setFieldValue('estado', ['JAL']);
                setSelectEstado([{
                    label: "Jalisco",
                    value: "JAL"
                }]);
            } else{
                setSelectEstado([]);
                setFieldValue('estado', []);
                const estados = paquetes.conceptos.find(c => c.id_concepto === '16000');
                setMaxEstados(Number(estados.valor));
                setEstadosTag(dataEstados);
            }
        }
    }, [paqueteArray, setFieldValue, sumaDia, values.desde, values.sistema, desde_con]);

    function changePaquete(paquete) {
        setFieldValue('id_paquete', paquete);
        setFieldValue('contratacion', 'Mensual');

        setFieldValue('hasta', dayjs(desde_con).add(1, 'months').subtract(1, "day").format('YYYY MMM DD'));

        setFieldValue('correos', [
            {
                correo : "",
            }
        ]);

        setFieldValue('telefonos', [
            {
                telefono : ""
            }
        ]);

        setFieldValue('usuarios', [values.usuarios[0]]);

        /**
         * @param p.id_paquete
         * @param p.id_paquete
         * @param conceptosP.conceptos
         * @param c.id_concepto
         * @param e.clave
         */
        const conceptoP = paqueteArray.find(p => p.id_paquete === paquete);
        if (conceptoP){
            setFieldValue('costo', conceptoP.costo);
            setConceptos({...conceptos,
                asuntos: conceptoP.conceptos.find(a => a.id_concepto === '11000'),
                consultas: conceptoP.conceptos.find(c => c.id_concepto === '12000'),
                historico: conceptoP.conceptos.find(h => h.id_concepto === '13000'),
            });

            const estados = conceptoP.conceptos.find(c => c.id_concepto === '16000');
            setMaxEstados(Number(estados.valor));
        }
    }

    useEffect(() => {
         if (values.estado.length > maxEstados) {
            setDisableTag(true);
            const only2 = values.estado.slice(1);
            setFieldValue('estado', only2);
            const first = selectEstado[0];
            setEstadosTag([...estadosTag, first]);
            setSelectEstado( s => s.slice(1));
        } else if (values.estado.length < maxEstados) {
            setDisableTag(false);
        } else setDisableTag(true);

    }, [values.estado, maxEstados, selectEstado, setFieldValue, estadosTag]);

    function changePeriodo(periodo) {
        setFieldValue('contratacion', periodo);
        const conceptoP = paqueteArray.find(p => p.id_paquete === formik.values.id_paquete);
        let num;
        switch (periodo) {
            case "Trimestral":
                num = 3;
             break
            case "Semestral":
                num = 6;
            break
            case "Anual":
                num = 12;
            break;
            default:
                num = 1;
                break;
        }

        setFieldValue('costo', Number(conceptoP.costo) * num);

        setFieldValue('hasta', dayjs(desde_con).add(num, 'months').subtract(1, "day").format('YYYY MMM DD'));
    }

    function handleChange(value) {

        value.forEach((val) => {
            setEstadosTag(estadosTag.filter((t) => t.value !== val));
        })

        if (value.length <= maxEstados){ //Cantidad máxima de estados por paquete
            setFieldValue('estado', value);
        } else {
            setDisableTag(true);
        }
    }

    function removeTag(e, estado){
        e.stopPropagation();
        setDisableTag(false);
        const newarray = values.estado.filter((t) => t !== estado.value);
        setFieldValue('estado', newarray);
        setSelectEstado(selectEstado.filter(t => t.value !== estado.value));
        setEstadosTag([...estadosTag, estado]);
    }

    function handleSelect(item){
        if (selectEstado.length <= maxEstados){
            setSelectEstado([...selectEstado, item]);
            setOpenTag(false);
        }
    }

    return (
        <>
            <div className="w-100">
                <div className="pb-8 pb-lg-10">
                    <h2 className="fw-bold text-gray-900" tabIndex={-1}>Paquete a Contratar</h2>
                    <div className="text-muted fw-semibold fs-6">Definir el paquete y el periodo de contrataci&oacute;n.</div>
                </div>
                <div className={'row'}>
                    <div className="col-md-6">
                        <Paquetes formik={formik} data={paqueteArray} changePaquete={changePaquete}></Paquetes>
                        <ErrorMessage name={'id_paquete'}></ErrorMessage>
                    </div>
                    <div className="col-md-6">
                        <PeriodoDeContratacion formik={formik} data={catalogo.periocidades} changePeriodo={changePeriodo} disable={paqueteArray.length === 0}></PeriodoDeContratacion>
                        <ErrorMessage name={'contratacion'}></ErrorMessage>
                    </div>
                </div>
                <div className={"row"}>
                    <div className="col-md-4">
                        <div className="form-floating mb-11">
                            <input type={'text'} className="form-control bg-gray-200 text-gray-700 border-0 text-uppercase"
                                   id="desde"
                                   name="desde"
                                   placeholder="inicio"
                                   value={formik.values.desde}
                                   disabled={true}
                            />
                            <label htmlFor="desde" className={"text-gray-700"}>Inicio</label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-floating mb-7">
                            <input
                                className={"form-control bg-gray-200 text-gray-700 border-0 text-uppercase"}
                                id="hasta"
                                name='hasta'
                                type='text'
                                placeholder={'Termino de contrato'}
                                value={formik.values.hasta}
                                disabled={true}
                            />
                            <label htmlFor='hasta' className='text-gray-700'>Termino </label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-floating mb-7">
                            <input
                                className={"form-control bg-gray-200 text-gray-700 border-0 text-uppercase"}
                                id="costo"
                                name='costo'
                                type='text'
                                placeholder={'costo'}
                                value={"$ " + formik.values.costo}
                                disabled={true}
                            />
                            <label htmlFor='costo' className='text-gray-700'>Costo</label>
                        </div>
                    </div>
                </div>
                <div className={"row"}>
                    <div className="col-md-4">
                        <div className="form-floating mb-11">
                            <input type="text" className="form-control bg-gray-200 text-gray-700 border-0 text-uppercase"
                                   id="asuntos"
                                   name="asuntos"
                                   placeholder="Asuntos"
                                   value={conceptos.asuntos.valor ?? ""}
                                   disabled={true}
                            />
                            <label htmlFor="asuntos" className={"text-gray-700"}>Asuntos</label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-floating mb-7">
                            <input
                                className={"form-control bg-gray-200 text-gray-700 border-0 text-uppercase"}
                                id="consultas"
                                name='consultas'
                                type='text'
                                placeholder={'Consultas'}
                                value={conceptos.consultas.valor ?? ""}
                                disabled={true}
                            />
                            <label htmlFor='consultas' className='text-gray-700'>Consultas</label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-floating mb-7">
                            <input
                                className={"form-control bg-gray-200 text-gray-700 border-0 text-uppercase"}
                                id="historico"
                                name='historico'
                                type='text'
                                placeholder={'Historico'}
                                value={conceptoText(conceptos.historico.valor) ?? ""}
                                disabled={true}
                            />
                            <label htmlFor='historico' className='text-gray-700'>Historico</label>
                        </div>
                    </div>
                </div>

                <div ref={taginputRef} className={"position-relative"}>
                    <TagPicker
                        block
                        container={() => taginputRef.current}
                        className={"border-0"}
                        data={estadosTag}
                        defaultValue={values.estado}
                        readOnly={values.sistema === 'BGDL'}
                        disabled={disableTag}
                        open={openTag}
                        value={values.estado}
                        placement={'topStart'}
                        onChange={handleChange}
                        onSelect={(value, item) => handleSelect(item)}
                        onOpen={() => setOpenTag(true)}
                        renderMenuItem={(label, item) => {
                            return (
                                <>
                                    <div className={"symbol symbol-35px symbol-circle "}>
                                        <span className={item.value + " symbol-label fw-bold fs-8"}>{item.value}</span>
                                    </div>
                                    <span className={"ms-2 text-uppercase "} >{label}</span>
                                </>
                            );
                        }}
                        renderValue={() => {
                            return(
                                selectEstado && selectEstado.map((estado) => {
                                    return(
                                        <span key={estado.value} className={'form-control-solid-bg'}>
                                        <div key={estado.value} className="symbol symbol-35px symbol-circle ms-2">
                                            <span className={estado.value + " symbol-label fw-bold fs-8"}>{estado.value}</span>
                                        </div>
                                        <span className={"ms-2 text-uppercase "}>{estado.label}</span>
                                        <button type={'button'} className={"btn btn-icon cursor-pointer"}
                                                onClick={(e) => removeTag(e, estado)}
                                                disabled={formik.values.sistema === 'BGDL'}
                                        >
                                            <i className="bi bi-x fs-2"></i>
                                        </button>
                                    </span>
                                    )
                                })
                            );
                        }}
                    />
                </div>
                <ErrorMessage name={'estado'}></ErrorMessage>
            </div>
        </>
    );
}

